// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__dCLzX","wrap":"Footer_wrap__IMgph","logo":"Footer_logo__KXlpN","nav":"Footer_nav__OaFr9"};